import styled from "styled-components";

export const SearchNTagSec = styled.div`
  width: 100%;
  display: flex;
  padding: 0 3rem;
  margin-bottom: 50px;
  background-color: #fff;
`;
export const SearchNTagContainer = styled.div`
  max-width: 1040px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap-reverse;
`;

export const TagContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 50%;
  margin-right: auto;

  @media screen and (max-width: 500px) {
    width: 100%;
  }
`;
export const TagContainerHeader = styled.div`
  font-weight: 700;
  font-size: 15px;
  margin-bottom: 10px;
  color: #071242;
`;

export const SearchBarContainer = styled.div`
  margin-left: 20px;
  height: fit-content;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: start;
  @media screen and (max-width: 500px) {
    width: 100%;
    margin-left: 0;
    margin-bottom: 20px;
  }
`;

export const SearchBarTitle = styled.div`
  color: #071242;
  font-size: 15px;
  font-weight: 600;
  background-color: #fff;
  top: -12px;
  left: 10px;
  padding: 1px 5px;
  position: absolute;
  width: fit-content;
`;
